<div class="content">
  @if (userSettingsRouterLink) {
    <a
      [routerLink]="userSettingsRouterLink"
      class="item"
      title="User Settings"
      i18n-title="@@User_Settings"
      pplPopoverClose>
      <ng-container *ngTemplateOutlet="userInfo"></ng-container>
    </a>
  }
  @if (userSettingsUrl) {
    <a
      [href]="userSettingsUrl"
      class="item"
      target="_blank"
      title="User Settings"
      i18n-title="@@User_Settings"
      pplPopoverClose>
      <ng-container *ngTemplateOutlet="userInfo"></ng-container>
    </a>
  }

  <ng-template #userInfo>
    @if (userProfile.pictureUrl) {
      <img
        [src]="userProfile.pictureUrl"
        [alt]="userProfile | pplName"
        class="avatar" />
    }
    @if (!userProfile.pictureUrl) {
      <div class="avatar">
        <ppl-icon svgIcon="contact-avatar"></ppl-icon>
      </div>
    }
    <div class="info">
      <div class="name">{{ userProfile | pplName }}</div>
      <div class="text">{{ userProfile.email }}</div>
    </div>
    <ppl-icon
      svgIcon="color-space-settings"
      class="item-top-icon"
      width="16px"
      height="16px"></ppl-icon>
  </ng-template>

  @if (currentSpace && selectSpaceUrl) {
    <a
      [href]="selectSpaceUrl"
      class="item item--space"
      title="Switch Space"
      i18n-title="@@Switch_Space"
      pplPopoverClose>
      <ng-container *ngTemplateOutlet="spaceInfo"></ng-container>
    </a>
  }
  @if (currentSpace && !selectSpaceUrl) {
    <div class="item item--space">
      <ng-container *ngTemplateOutlet="spaceInfo"></ng-container>
    </div>
  }

  <ng-template #spaceInfo>
    @if (currentSpace.pictureUrl) {
      <img
        [src]="currentSpace.pictureUrl"
        [alt]="currentSpace.name"
        class="avatar" />
    }
    @if (!currentSpace.pictureUrl) {
      <div class="avatar">
        <ppl-icon svgIcon="pipeline-avatar"></ppl-icon>
      </div>
    }

    <div class="info">
      <div class="name">{{ currentSpace.name }}</div>
      <div
        class="text"
        i18n="@@Current_Space">
        Current space
      </div>
    </div>

    @if (selectSpaceUrl) {
      <ppl-icon
        svgIcon="color-switch-space-blue"
        class="item-top-icon"
        width="16px"
        height="16px"></ppl-icon>
    }
  </ng-template>

  <div class="actions">
    <button
      [style.visibility]="currentSpace && enableSpaceSettings ? 'visible' : 'hidden'"
      (click)="openSpaceSettings.emit(true)"
      pplButton
      pplButton1
      pplButtonSmall
      pplPopoverClose>
      <ppl-icon
        svgIcon="color-space-settings"
        width="16px"
        height="16px"></ppl-icon>
      <ng-container i18n="@@Settings">Settings</ng-container>
    </button>

    <a
      [href]="logoutHref"
      pplButton
      pplButton6
      pplButtonSmall
      pplPopoverClose>
      <ppl-icon
        svgIcon="color-sign-out"
        width="16px"
        height="16px"></ppl-icon>
      <ng-container i18n="@@Sign_Out">Sign Out</ng-container>
    </a>
  </div>
</div>
